import React from "react";

function Privacy() {
    return (
        <div style={styles.container}>
            <h1>Privacy Policy</h1>

            <p>
                At Scan4Help, we value your privacy. This Privacy Policy explains how we
                collect, use, and protect your information.
            </p>

            <h3>Information We Collect</h3>
            <p>
                We collect basic details such as name, phone number, and emergency
                contact information provided by users.
            </p>

            <h3>How We Use Information</h3>
            <p>
                The collected information is used only to enable emergency contact access
                through QR scanning and to improve our services.
            </p>

            <h3>Data Security</h3>
            <p>
                We implement reasonable security measures to protect your data. However,
                no method of transmission over the internet is completely secure.
            </p>

            <h3>Third-Party Sharing</h3>
            <p>
                We do not sell or share your personal data with third parties except when
                required by law.
            </p>

            <h3>Contact Us</h3>
            <p>
                If you have any questions, please contact us at support@scan4help.app
            </p>

            <p style={styles.footer}>Last updated: {new Date().toLocaleDateString()}</p>
        </div>
    );
}

const styles = {
    container: {
        maxWidth: "800px",
        margin: "auto",
        padding: "20px",
        lineHeight: "1.6",
        fontFamily: "Arial"
    },
    footer: {
        marginTop: "20px",
        fontSize: "12px",
        color: "gray"
    }
};

export default Privacy;